export default "__VITE_ASSET__C65d6ZYF__"